import QueryParamLink from './QueryParamLink';

export default QueryParamLink;
